import { defineMessages } from 'react-intl';

export default defineMessages({
  // About
  description: {
    id: 'product.time.description',
    defaultMessage: 'A web-based time tracking system',
    description: 'Description of time product',
  },

  // Payment
  monthlyPayment: {
    id: 'product.time.feature.monthlyPayment',
    defaultMessage: 'per month per user (net price)',
    description: 'Info about monthly payment',
  },

  // Standard
  standard: {
    id: 'product.time.feature.standard',
    defaultMessage: 'Standard',
    description: 'Header text for package',
  },

  limitMessageStandard: {
    id: 'product.time.feature.limitMessageStandard',
    defaultMessage: '3 users minimum',
    description: 'Info text regarding product pricing limitation',
  },

  featureTrackTime: {
    id: 'product.time.feature.featureTrackTime',
    defaultMessage: 'Track your time and assign it to projects',
    description: 'Info text regarding feature in time pricing',
  },
  featureTrackHolidays: {
    id: 'product.time.feature.featureTrackHolidays',
    defaultMessage: 'Track holidays, vacancies and illness',
    description: 'Info text regarding feature in time pricing',
  },
  featureGitlab: {
    id: 'product.time.feature.featureGitlab',
    defaultMessage:
      'Gitlab project support: sync your projects with your Gitlab',
    description: 'Info text regarding feature in time pricing',
  },
  featureGitlabIssue: {
    id: 'product.time.feature.featureGitlabIssue',
    defaultMessage:
      'GitLab issue support: entries assigned to issues show up in your GitLab ',
    description: 'Info text regarding feature in time pricing',
  },
  featureJira: {
    id: 'product.time.feature.featureJira',
    defaultMessage: 'Jira project support: sync your projects with your Jira',
    description: 'Info text regarding feature in time pricing',
  },
  featureLogins: {
    id: 'product.time.feature.logins',
    defaultMessage: 'Logins: Local Account, GitLab or Jira',
    description: 'Info text regarding feature in time pricing',
  },
  featureBillable: {
    id: 'product.time.feature.billable',
    defaultMessage: 'Projects can be billable or non-billable',
    description: 'Info text regarding feature in time pricing',
  },
  featureAdminSupervice: {
    id: 'product.time.feature.adminSupervice',
    defaultMessage: 'Admin mode: supervise your team hours',
    description: 'Info text regarding feature in time pricing',
  },
  featureAdminCustomProjects: {
    id: 'product.time.feature.adminCustomProjects',
    defaultMessage: 'Admin mode: create custom projects with categories',
    description: 'Info text regarding feature in time pricing',
  },
  featureAdminExport: {
    id: 'product.time.feature.adminExport',
    defaultMessage: 'Admin mode: export project hours as Pdf',
    description: 'Info text regarding feature in time pricing',
  },

  // Pro
  pro: {
    id: 'product.time.feature.pro',
    defaultMessage: 'Pro',
    description: 'Header text for package',
  },

  limitMessagePro: {
    id: 'product.time.feature.limitMessagePro',
    defaultMessage: '5 users minimum',
    description: 'Info text regarding product pricing limitation',
  },
  featureHeaderTextPro: {
    id: 'product.time.feature.featureHeaderTextPro',
    defaultMessage: 'All Standard features',
    description:
      'Entry line for professional license type on price page, stating that it includes all standard benefits in addition to the professional benefits',
  },

  featureTeamControllingAll: {
    id: 'product.time.feature.teamControllingAll',
    defaultMessage:
      'Team Controlling: see team hours and projects at one glance',
    description: 'Info text regarding feature in time pricing',
  },
  featureTeamControllingIndividual: {
    id: 'product.time.feature.teamControllingIndividual',
    defaultMessage:
      'Team Controlling: see team member hours for any individual period',
    description: 'Info text regarding feature in time pricing',
  },
  featureShortWork: {
    id: 'product.time.feature.featureShortWork',
    defaultMessage:
      'Short Work: create short work periods and assign users to every short work period',
    description: 'Info text regarding feature in time pricing',
  },
  featureShortWorkFilter: {
    id: 'product.time.feature.featureShortWorkFilter',
    defaultMessage:
      'Short Work: every user can filter by the short work periods he is assigned to',
    description: 'Info text regarding feature in time pricing',
  },
  featureShortWorkExport: {
    id: 'product.time.feature.featureShortWorkExport',
    defaultMessage:
      'Short Work: The spent hours can be exported per user of a short work period',
    description: 'Info text regarding feature in time pricing',
  },

  // On Premise
  onPremise: {
    id: 'product.time.feature.onPremise',
    defaultMessage: 'On Premise',
    description: 'Header text for package',
  },

  limitMessageOnPremise: {
    id: 'product.time.feature.limitMessageOnPremise',
    defaultMessage: '10 users minimum',
    description: 'Info text regarding product pricing limitation',
  },
  featureHeaderTextOnPremise: {
    id: 'product.time.feature.featureHeaderTextOnPremise',
    defaultMessage: 'All Pro features',
    description:
      'Entry line for professional license type on price page, stating that it includes all standard benefits in addition to the professional benefits',
  },

  featureDockerized: {
    id: 'product.time.feature.dockerized',
    defaultMessage: 'Fully dockerized in-house setup',
    description: 'Info text regarding feature in time pricing',
  },
  featureTimeTrackingInHouse: {
    id: 'product.time.feature.timeTrackingInHouse',
    defaultMessage: 'All time tracking data stays in house',
    description: 'Info text regarding feature in time pricing',
  },
});



// WEBPACK FOOTER //
// ./src/routes/time/messages.js